import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";

export async function rejectDeliveryDateChange(requestId) {
  const axios = axiosInstance().primoLab;

  const { data } = await axios.post(`/clinic-deliveries/reject-delivery-date-change/${requestId}`);
  return data;
}
